__turbopack_context__.v({
  "captionTitle": "rDEnrG_captionTitle",
  "description": "rDEnrG_description",
  "imgContainer": "rDEnrG_imgContainer",
  "imgTextContainer": "rDEnrG_imgTextContainer",
  "imgWrapper": "rDEnrG_imgWrapper",
  "root": "rDEnrG_root",
  "textContainer": "rDEnrG_textContainer",
});
